// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: auto;
  text-align: center;
  font-size: 16px;
  font-weight: 300;
  letter-spacing: 0.15px;
  color: #111;
  border-style: solid;
  border-width: 1px 0;
}
.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy.NoticeBar_success__AiBwz {
  border-color: #2ee68c;
  background-color: #e6fff2;
}
.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy.NoticeBar_success__AiBwz svg {
  color: #15ad5c;
}
.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy.NoticeBar_error__NSxff {
  border-color: #ff7591;
  background-color: #ffedf0;
}
.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy.NoticeBar_error__NSxff svg {
  color: #e64949;
}
.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy.NoticeBar_info__DDnCp {
  border-color: #75b1ff;
  background-color: #e6f1ff;
}
.NoticeBar_root__kPSBS .NoticeBar_notice__Yk6Yy.NoticeBar_info__DDnCp svg {
  color: #3a8df9;
}`, "",{"version":3,"sources":["webpack://./src/components/molecules/NoticeBar/NoticeBar.module.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAAJ;AACI;EACE,qBAAA;EACA,yBAAA;AACN;AAAM;EACE,cAAA;AAER;AACI;EACE,qBAAA;EACA,yBAAA;AACN;AAAM;EACE,cAAA;AAER;AACI;EACE,qBAAA;EACA,yBAAA;AACN;AAAM;EACE,cAAA;AAER","sourcesContent":[".root {\r\n  .notice {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    gap: 8px;\r\n    height: auto;\r\n    text-align: center;\r\n    font-size: 16px;\r\n    font-weight: 300;\r\n    letter-spacing: 0.15px;\r\n    color: #111;\r\n    border-style: solid;\r\n    border-width: 1px 0;\r\n    &.success {\r\n      border-color: #2ee68c;\r\n      background-color: #e6fff2;\r\n      svg {\r\n        color: #15ad5c;\r\n      }\r\n    }\r\n    &.error {\r\n      border-color: #ff7591;\r\n      background-color: #ffedf0;\r\n      svg {\r\n        color: #e64949;\r\n      }\r\n    }\r\n    &.info {\r\n      border-color: #75b1ff;\r\n      background-color: #e6f1ff;\r\n      svg {\r\n        color: #3a8df9;\r\n      }\r\n    }\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `NoticeBar_root__kPSBS`,
	"notice": `NoticeBar_notice__Yk6Yy`,
	"success": `NoticeBar_success__AiBwz`,
	"error": `NoticeBar_error__NSxff`,
	"info": `NoticeBar_info__DDnCp`
};
export default ___CSS_LOADER_EXPORT___;
